<template>
	<PublishButtonDropdown
		arrow-left="357"
		:nudge-top="-30"
		warningIconReverted
		:nameOfAction="'test'"
		:showWarningIcon="showWarningIcon"
		:problematicNodes="problematicNodes"
	>
		<template #activator>
			<AppTextTooltip class="pl-2 pb-1" tooltipText="Test your feature" bottom>
				<AnemicButton :disabled="!allowedToPublish" :loading="testLoading" @click="onTestClick" class="test-button pa-0" tile>
					<AppIcon name="test-button-play" :height="18" :width="18" />
				</AnemicButton>
			</AppTextTooltip>
		</template>
	</PublishButtonDropdown>
</template>

<script>
import props from './PublishButton.props';
import PublishButtonDropdown from './PublishButtonDropdown.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { testWorkflow } from '@/store/modules/workflows/actions';
import { mapActionsShorthand } from '@/store/utils/mappers';
import ErrorHandlingService from '@/utils/error-handling-service';
import { WORKFLOW_ERROR_CODES } from '@/utils/workflow-service.const';
export default {
	name: 'TestButton',
	props: { workflowId: { type: Number }, ...props },
	components: { PublishButtonDropdown },
	methods: {
		...mapActionsShorthand({ testWorkflow }),
		onTestClick(e) {
			if (!this.canPublish) {
				return;
			}
			e.stopPropagation();
			this.testClicked();
		},
		async testClicked() {
			if (this.canPublish) {
				this.testLoading = true;
				try {
					await this.testWorkflow({ id: this.workflowId });
					this.$emit('test-flow');
				} catch (err) {
					if (
						ErrorHandlingService.extractErrorCode(err) === WORKFLOW_ERROR_CODES.TEST_MISSING_DEPENDENCY_NODES &&
						ErrorHandlingService.extractErrorMetadata(err)
					) {
						await AppDialogManagerService.openPublishFlowErrorsDialog({
							erroredNodes: ErrorHandlingService.extractErrorMetadata(err),
						});
					} else {
						this.$toast.error('Error has occurred while trying to test the workflow');
					}
				} finally {
					this.testLoading = false;
				}
			}
		},
	},
	data() {
		return { testLoading: false };
	},
};
</script>

<style lang="scss" scoped>
.test-button {
	width: 30px !important;
	height: 30px !important;
	border-radius: 6px !important;
	background: var(--white) !important;
	border: 1px solid #d6dde8 !important;
}
</style>
